import StoreList from './StoreList'
import PopoverNavigationMenu from './PopoverNavigationMenu'
import UserProfileSection from './UserProfileSection'

const ProfileOverlay = ({ closePopover }: { closePopover: () => void }) => {
  return (
    <div className='flex flex-col divide-y-[0.5px] divide-zinc-200 w-full overflow-hidden '>
      <StoreList quantity={3} />
      <PopoverNavigationMenu closePopover={closePopover} />
      <UserProfileSection closePopover={closePopover} />
    </div>
  )
}

export default ProfileOverlay
